import AbstractCommand from "../../core/application/AbstractCommand";
import ScormEvent from "../events/ScormEvent";
import ScormController from "./ScormController";

export default class ScormCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {ScormController} scormController 
     */
    constructor(dispatcher, scormController) {
        super(dispatcher);

        this._scormController = scormController;
    }

    execute(evt) {
        const evtType = evt.type;
        switch (evtType) {
            case ScormEvent.START_SESSION:
                this._startSession();
                break;
            case ScormEvent.END_SESSION:
                this._endSession();
                break;
            default:
                console.warn(`Unhandled event type: ${evtType}`);
                break;
        }
    }

    _startSession() {
        console.log("Starting Scorm session...");
        this._scormController.initialize();
    }

    _endSession() {
        this._scormController.endSession(); // this will wrap up the SCORM session
        console.log("Ending Scorm session...");
    }
}